import { Accordion } from '@chakra-ui/accordion'
import { Button, HStack, Link } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { UsefulResources } from '../../components/Support'
import { UserContext } from '../../providers'
import { MainContentHeadingBox } from '../Base/MainContent'

const UsefulResourcesLayout = (): React.ReactElement => {
  const { t } = useTranslation()
  const { user } = useContext(UserContext)
  return (
    <>
      <MainContentHeadingBox reverse={true} justifyContent="right">
        <HStack spacing={4}>
          <Link
            isExternal
            _hover={{ textDecoration: 'none' }}
            href="https://meetings.hubspot.com/rahul52/imagekit-demo-meeting"
          >
            <Button>{t('contact_sales')}</Button>
          </Link>
          <Link isExternal href="https://community.imagekit.io/">
            <Button>{t('ask_support_forums')}</Button>
          </Link> 
          {user?.isEligibleForCSMSupport ? (
            <Link
              p={1}
              isExternal
              _hover={{ textDecoration: 'none' }}
              href={user.csmBookLink}
            >
              <Button>{t('speak_with_csm')}</Button>
            </Link>
          ) : (
            <Link
              p={1}
              isExternal
              _hover={{ textDecoration: 'none' }}
              href="https://imagekit.io/docs/how-pricing-works#custom-pricing-plans"
            >
              <Button>{t('speak_with_csm_not_available')}</Button>
            </Link>
          )}
        </HStack>
      </MainContentHeadingBox>

      <Accordion borderColor="#9ea3ad33" allowToggle>
        <UsefulResources />
      </Accordion>
    </>
  )
}

export default UsefulResourcesLayout
